module.exports = __webpack_public_path__ + "b903ec5566d07517fe337be734cd085d.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/electronica prevenir.png
// module id = 598
// module chunks = 0